import requestProvider from "./axiosHandler";

const getAllRole = async () => {

    return requestProvider
        .get('/role/get-all')
};

const updateRole = (list) => {

    return requestProvider
        .put('/role', {
            name: list.name,
            code: list.code,
            id: list.id
        })
};

const deleteRole = (id) => {

    return requestProvider
        .delete(`/role/${id}`)
};

const createRole = (list) => {

    return requestProvider
        .post('/role', {
            name: list.name,
            code: list.code,
            deleted: false
        })
};

const getRoleById = (id) => {

    return requestProvider
        .get(`/role/${id}`)
};

const getRolesWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/role?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {createRole, getAllRole, deleteRole, updateRole, getRoleById, getRolesWithPage}